import numeral from 'numeral'

import { CustomerLead } from '../../core/domain/customerLead.model'
import { OfferData } from '../../core/domain/offerData.model'
import { OfferDocumentDTO, PriceDTO } from '../../core/domain/offerDocument.dto'
import OfferService from '../../core/services/offer.service'
import {
  clearOfferDocumentId,
  getOfferDocumentId,
} from '../../core/services/storage.service'
import { LifecyclePresenter } from '../_components/ConnectComponent'
import { AdobeEventManager } from '../_utils/adobeAnalytics'
import { dataLayer } from '../_utils/adobeAnalytics/adobeAnalytics.conf'
import { getDefaultLanguage } from '../_utils/i18next'
import { goToHelvetiaLandingPage } from '../_utils/links'
import { generalConditions, mountDownablePDF } from '../_utils/pdfs/pdf'
import { SummaryRaw, View } from './Summary.view'

export class SummaryPresenter implements LifecyclePresenter<View> {
  private view!: SummaryRaw
  private stepPageNumber: number = 7
  protected offer: OfferData
  protected customer: CustomerLead
  protected document: OfferDocumentDTO
  protected obtainedPrice: PriceDTO
  protected tax: number = 0

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    await this.getOfferDocument()

    dataLayer.page.category.applicationStep = 'step7-offer-summary'
    AdobeEventManager.track('calc_step')

    this.view.setInitialValues(
      this.offer,
      this.customer,
      this.document,
      this.obtainedPrice,
    )
  }

  getOfferDocument = async () => {
    this.document = await OfferService.getOfferDocument(getOfferDocumentId())

    this.offer = this.document.offerData
    this.customer = this.document.customerLead

    try {
      this.obtainedPrice = await OfferService.getOfferPrice()

      const { insuredVehicle1, insuredVehicle2, insuredVehicle3, insuredVehicle4, insuredVehicle5 } = this.offer
      const totalSum = insuredVehicle1 + insuredVehicle2 + insuredVehicle3 + insuredVehicle4 + insuredVehicle5

      dataLayer.product.productInfo.productCategory =
        'Carriers liability policy offer'
      dataLayer.product.productInfo.productInsuranceSum = numeral(totalSum).format('0,0.00')
      dataLayer.product.productInfo.productDeductible = numeral(
        this.offer.deductible,
      ).format('0,0.00')
      dataLayer.product.productInfo.productInsurancePremium = numeral(
        this.obtainedPrice.price + this.obtainedPrice.taxes,
      ).format('0,0.00')

      dataLayer.products = `;Carriers Liability;1;${this.obtainedPrice.price + this.obtainedPrice.taxes};;eVar53=${totalSum}|eVar58=${this.offer.deductible}`

      AdobeEventManager.emit('summary_get_price', 'insurance_sum')
    } catch (error) {
      console.log(error)
      const statusError = JSON.parse(error.request.response)

      if (
        error &&
        ((error.response && error.response.status === '422') ||
          statusError.status === 422)
      ) {
        this.view.showErrorModal()
        clearOfferDocumentId()
      }
    }
  }

  onShowViewModal = () => this.view.showModal()

  onHideModalHandler = () => {
    this.view.showLoading()
    goToHelvetiaLandingPage()
  }

  onBackToPortal = () => {
    OfferService.saveOfferData(this.offer).then(() => {
      this.view.props.history.push('/portal')
    })
  }

  onContract = async () => this.gotToContractingProcess()

  gotToContractingProcess = () => {
    AdobeEventManager.emit(
      'summary_continue_goto_contract-step1',
      'custom_links',
    )
    setTimeout(() => this.view.props.history.push('/contract/duration'), 1500)
  }

  onSaveAndRetreiveLater = () => {
    OfferService.saveOfferData(this.offer).then(() => {
      OfferService.saveAndRetrieve().then(() => {
        AdobeEventManager.emit('summary_call_Save&Retrieve', 'custom_links')


        setTimeout(() => this.onShowViewModal(), 1000)
      })
    })
  }

  onShowGeneralConditionPDF = () => {
    let pdf = generalConditions[getDefaultLanguage()]

    dataLayer.event.eventInfo.fileDownload = pdf
    window.open(pdf, '_blank')

    AdobeEventManager.emit(
      'summary_download_general_conditions_pdf',
      'file_downloads',
    )
  }

  onDownloadOfferPDF = async () => {
    this.view.showLoading()

    try {
      let pdf = await OfferService.getOfferPDF(getOfferDocumentId())
      mountDownablePDF(pdf, this.document.offerNumber, false)

      AdobeEventManager.emit('summary_download_offer_pdf', 'file_downloads')

      this.view.hideLoading()
    } catch (error) {
      console.log(error)

      this.view.hideLoading()
      alert('It is NOT available to get PDF for your query')
    }
  }

  moveTo = (page: string) => this.view.props.history.push(page)

  manageLastVisitedStep = () => {
    let progress = this.offer.progressMask
    this.offer.progressMask =
      progress.substr(0, this.stepPageNumber - 1) +
      '1' +
      progress.substr(this.stepPageNumber)

    OfferService.saveOfferData(this.offer)
  }
}
